import { AppError } from "./AppError"

export class MissingContextError extends AppError {
  constructor(message: string) {
    super(message)
    this.name = "MissingContextError"
  }
}
